// auftrag_split — paper left with one serif paragraph, full-height image right (v15 slide 3:
// image w527 from x755, body Newsreader ~27px, line-height 1.4, vertically centred).
import type { AuftragSplitContent } from '../../../../shared/deckTypes.js';
import { Abs, Brand, Dkp, Emph, Eyebrow, FramedImg, PageNo, splitXOf } from './chrome.js';

export default function AuftragSplitPreview({ content, pageNo }: {
  content: AuftragSplitContent;
  pageNo?: number | null;
}) {
  const c = content;
  const splitX = splitXOf(c as Record<string, unknown>, 755);
  const textW = splitX - 64 - 36;
  return (
    <Dkp>
      <Eyebrow text={c.eyebrow ?? ''} />

      {/* serif paragraph from y120, the sans value paragraph under it (v15 slide 3) */}
      <Abs x={64} y={120} w={textW}>
        <div className="dkp-serif" style={{ fontSize: 27, lineHeight: 1.4, fontWeight: 500 }}>
          {c.body}
        </div>
      </Abs>
      {c.body2 ? (
        <Abs x={64} y={385} w={textW}>
          <div style={{ fontSize: 17.3, fontWeight: 500, color: '#121316', lineHeight: 1.55 }}>
            <Emph text={c.body2} />
          </div>
        </Abs>
      ) : null}

      {/* right-hand image, full height from the split edge (v15: x755) */}
      {c.image ? (
        <Abs x={splitX} y={0} w={1280 - splitX} h={720} style={{ overflow: 'hidden' }}>
          <FramedImg src={c.image} content={c as Record<string, unknown>} slotKey="image" />
        </Abs>
      ) : null}

      <Brand />
      <PageNo n={pageNo} />
    </Dkp>
  );
}
